import React, { useState, useEffect } from 'react';

const RefreshFiltersAndPagesButtons = props => {
    const filterOptionMenu = props.filterOptionMenu;
    const filter = props.filter;
    const setFilter = props.setFilter;
    const page = props.page;
    const setPage = props.setPage;
    const maxPage = props.maxPage;

    let FilterRadio = (label, field, value) => {
        let setFilterField = () => {
        let filterCopy = {...filter};
        filterCopy[field] = value;
        setFilter( filterCopy );
        };
        
        return (<li className={props.isRefreshing ? " disabled" : ""}  onClick={(e)=> e.stopPropagation()}> <a onClick={props.isRefreshing ? (e)=>{e.stopPropagation()} : (e)=>{setFilterField();e.stopPropagation()} }>
            <input type="radio" checked={ value == filter[field] } /> {label}
        </a>
        </li>);
    };

    let makeFilterRadioGroup = ( field, labels ) => {
        return labels.map( x => FilterRadio( x[0], field, x[1] ) );
    }

    let pageUp = () => {
        if ( !props.isRefreshing )
        if ( page + 1 < maxPage )
            setPage( page + 1 );
    }

    let pageDown = () => {
        if ( !props.isRefreshing )
        if ( page - 1 >= 0 )
            setPage( page - 1 );
    }

    let pageInput = maxPage > 1 ? [
        (<div className={"btn btn-primary btn-xs panel-nav-btn-group " + (props.isRefreshing ? " disabled" : "")} onClick={pageDown}><span>&laquo;</span></div>),
        (<div className="btn btn-xs"><span>{page + 1} / {maxPage}</span></div>),
        (<div className={"btn btn-primary btn-xs" + (props.isRefreshing ? " disabled" : "")} onClick={pageUp}><span>&raquo;</span></div>)
    ] : []

    let filterScheduleTypeComponent = makeFilterRadioGroup("filterScheduleType", [
        ["All", 'all'],
        ["Scheduled", 'scheduled'],
        ["Unscheduled", 'unscheduled']
    ]);

    let filterActionTypeComponent = makeFilterRadioGroup("filterActionType",  [
        ["All", 'all'],
        ["Calls","Call"],
        ["Emails","Email"],
        ["Presentations","Presentation"],
        ["Other","Other"]
    ]);

    let filterUserTypeComponent = makeFilterRadioGroup("filterUser",  [
        ["You", 'currentUser'],
        ["Anyone", 'all'],
    ]);

    let filterShowHidden = makeFilterRadioGroup("showHidden",  [
        ["Hide Hidden", false],
        ["Include Hidden", true],
    ]);
    
    let onSearchFilterChange = ( event ) => {
        let filterCopy = {...filter};
        filterCopy['searchField'] = event.target.value;
        setFilter( filterCopy );
    };

    let submitFilterOnEnter = ( event ) => {
        if (event.key === 'Enter') {
            onSearchFilterChange( event )
        }
    }

    let filterSearchBox = (
    <li className={props.isRefreshing ? " disabled" : ""} onClick={(e)=> e.stopPropagation()}> 
        <a>
            <input type="text" class="form-control" placeholder="Search..." onBlur={onSearchFilterChange} onKeyPress={submitFilterOnEnter}/>
        </a>
    </li>);

    let allFilterComponents = [];

    allFilterComponents = Object.entries({
        "showSearch": filterSearchBox,
        "user": filterUserTypeComponent,
        "actionType": filterActionTypeComponent, 
        "scheduleType": filterScheduleTypeComponent, 
        "showHidden": filterShowHidden
    })
    .filter( ([key, _]) => filterOptionMenu.indexOf( key ) !== -1 )
    .map( ([ _, comp ]) => [ comp, <li role="separator" class="divider" onClick={(e)=> e.stopPropagation()} /> ] )

    if ( allFilterComponents.length > 0 )
       allFilterComponents[allFilterComponents.length - 1].pop();
   
    return (
        <div className="btn-group btn-group-xs panel-nav-btn-group">
            <div className={"btn btn-primary btn-xs" + (props.isRefreshing ? " disabled" : "")} onClick={props.doRefresh}>Refresh</div>

            <div className="btn btn-primary btn-xs dropdown-toggle" data-toggle='dropdown'>Filters</div>
            <ul className="dropdown-menu" onClick={(e)=> e.stopPropagation()}>
                {allFilterComponents}
            </ul>
            {pageInput}

        </div>
    );
};

export default RefreshFiltersAndPagesButtons;
